module.exports = __webpack_public_path__ + "static/prague-005944a511c583b5487e84a64ec3a996.png";